"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TagsGroup = _interopRequireDefault(require("../../TagsGroup/TagsGroup"));
var _useHasErrors = require("../../../common/useHasErrors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.OrganisationMember-container {\n  box-sizing: content-box;\n  margin: auto; }\n  .OrganisationMember-container .info-container {\n    max-width: 100%;\n    width: 244px; }\n  .OrganisationMember-container img {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1;\n    object-fit: cover; }\n  .OrganisationMember-container .name {\n    margin-bottom: 0px;\n    max-width: 100%; }\n  .OrganisationMember-container .professional_function {\n    max-width: 204px; }\n  .OrganisationMember-container .diploma_title {\n    margin-top: 2px; }\n  .OrganisationMember-container .tags-group {\n    display: flex;\n    flex-wrap: wrap; }\n  .OrganisationMember-container .bx--tag {\n    display: flex;\n    align-items: center; }\n    .OrganisationMember-container .bx--tag span {\n      font-family: 'Helvetica Neue LT Roman';\n      line-height: 100%;\n      text-decoration: none !important; }\n\n@media (max-width: 66rem) {\n  .OrganisationMember-container .info-container {\n    max-width: 100%;\n    width: 312px;\n    margin-left: 0px; } }\n\n@media (max-width: 42rem) {\n  .OrganisationMember-container .info-container {\n    max-width: 100%;\n    width: 288px;\n    margin-left: 0px; } }\n";
  const fileName = "OrganisationMember_OrganisationMember";
  const element = document.querySelector("style[data-sass-component='OrganisationMember_OrganisationMember']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const requiredProps = ['firstname', 'lastname', 'email'];
const OrganisationMember = props => {
  const {
    picture,
    firstname,
    lastname,
    academic_title,
    role,
    diploma_title,
    email,
    professional_group_membership,
    section_memberships,
    gender
  } = props;
  const sectionTags = section_memberships?.map(el => {
    return {
      label: el,
      type: 'quaternary'
    };
  }) || [];
  const hasErrors = (0, _useHasErrors.useHasErrors)(requiredProps, props);
  const defaultImage = `/images/defaultEmployee_${gender?.toUpperCase()}.jpg`;
  const src = picture ? picture : gender ? defaultImage : null;
  if (hasErrors) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "OrganisationMember-container "
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "info-container sia-margin-02-left sia-border-01-bottom sia-padding-04-bottom sia-margin-02-bottom"
  }, src && /*#__PURE__*/_react.default.createElement("img", {
    className: "sia-margin-02-bottom",
    src: src,
    alt: firstname
  }), /*#__PURE__*/_react.default.createElement("h3", {
    className: "name sia-text-12"
  }, `${academic_title || ''} ${firstname}`), /*#__PURE__*/_react.default.createElement("h3", {
    className: "lastname sia-text-12 sia-margin-02-bottom"
  }, lastname), /*#__PURE__*/_react.default.createElement("p", {
    className: "role sia-text-03",
    dangerouslySetInnerHTML: {
      __html: role
    }
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "diploma_title sia-text-08"
  }, diploma_title), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-08 sia-margin-02-top"
  }, /*#__PURE__*/_react.default.createElement(_TagsGroup.default, {
    items: [...(professional_group_membership ? [{
      label: professional_group_membership,
      type: 'quinary'
    }] : []), ...sectionTags]
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: "email sia-text-08 sia-padding-02-top"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: `mailto:${email}`
  }, "E-Mail"))));
};
OrganisationMember.propTypes = {
  picture: _propTypes.default.string,
  firstname: _propTypes.default.string.isRequired,
  lastname: _propTypes.default.string.isRequired,
  diploma_title: _propTypes.default.string,
  email: _propTypes.default.string.isRequired,
  academic_title: _propTypes.default.string,
  role: _propTypes.default.string,
  sia_membership: _propTypes.default.string,
  professional_group_membership: _propTypes.default.string,
  section_memberships: _propTypes.default.array
};
var _default = exports.default = OrganisationMember;